export const messageValidator = {
    email_required: "* Email không được bỏ trống",
    email_invalid: "* อีเมลไม่อยู่ในรูปแบบที่ถูกต้อง โปรดตรวจสอบอีกครั้ง",
    password_required: "* Mật khẩu không được bỏ trống",
    password_min: "* รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร",
    user_name_required: "* Tên hiển thị không được bỏ trống",
    user_name_size: "* ชื่อผู้ใช้ต้องมีความยาว 3-15 อักขระ"
}